type Mql = MediaQueryList;

type AnyMql = Mql & {
  addEventListener?: (type: "change", listener: () => void) => void;
  removeEventListener?: (type: "change", listener: () => void) => void;
  addListener?: (listener: () => void) => void;
  removeListener?: (listener: () => void) => void;
};

function asAnyMql(mql: Mql): AnyMql {
  return mql as unknown as AnyMql;
}

/**
 * Subscribe to MediaQueryList change events in a cross-browser way (Safari fallback).
 * Returns an unsubscribe function.
 */
export function subscribeToMediaQuery(mql: Mql, handler: () => void): () => void {
  const anyMql = asAnyMql(mql);
  if (typeof anyMql.addEventListener === "function") {
    anyMql.addEventListener("change", handler);
    return () => anyMql.removeEventListener?.("change", handler);
  }

  if (typeof anyMql.addListener === "function") {
    anyMql.addListener(handler);
    return () => anyMql.removeListener?.(handler);
  }

  return () => {};
}
